export class OnlineStatusResource {
    public static $inject = ["$http"];
    constructor(private $http: angular.IHttpService) {}

    /**
     *
     * @param userIds
     * @returns {Promise<any[]>}
     */
    public getOnlineStatus(userIds: string[]): Promise<any[]> {
        return this.$http.get(`/xapi/onlinestatus?ids=${userIds.join(",")}`).then((response: angular.IHttpPromiseCallbackArg<any[]>) => {
            return response.data;
        }) as any;
    }
}
